import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Text, Box, Flex, Link
} from 'components/ui';
import checkoutUtils from 'utils/Checkout';
import PromiseDateAndItems from 'components/FrictionlessCheckout/ShippingMethods/PromiseDateAndItems/PromiseDateAndItems';
import InfoButton from 'components/InfoButton/InfoButton';

const { FULLFILLMENT_TYPE } = checkoutUtils;

function AutoReplenishShippingGroups(props) {
    const {
        locales: { items, autoReplenish, deliveryFrequency },
        replenishItemsQuantity,
        isReplenOnly,
        isPhysicalGiftCard,
        shippingMethod,
        deliveryGroups,
        isEditView,
        showAutoReplenishModal,
        openAutoReplenishProductsModal
    } = props;

    const showSplitEDD = deliveryGroups?.length > 0;
    const shouldRenderTitle = !isReplenOnly || (isReplenOnly && !isEditView);
    const cutOffDescriptionForSplitEdd = deliveryGroups.length && !isPhysicalGiftCard && shippingMethod?.promiseDateSplitCutOffDescription;
    const ARDeliveryGroups = deliveryGroups?.length && checkoutUtils.seperateItemsinDeliveryGroupByFullfullment(deliveryGroups, FULLFILLMENT_TYPE.AR);
    const deliveryMethods = showSplitEDD ? ARDeliveryGroups : [shippingMethod];

    return (
        <>
            <Flex alignItems='center'>
                {shouldRenderTitle && (
                    <Text
                        is='h4'
                        fontWeight='bold'
                        marginTop={isEditView ? 3 : 0}
                        children={`${autoReplenish} • ${items} (${replenishItemsQuantity})`}
                    />
                )}

                {!isEditView && (
                    <InfoButton
                        size={16}
                        pt={1}
                        pb={0}
                        margin={0}
                        onClick={showAutoReplenishModal}
                    />
                )}
            </Flex>
            {deliveryMethods?.map((deliveryMethod, index) => (
                <Box {...(showSplitEDD && { marginBottom: index !== deliveryGroups.length - 1 && 4 })}>
                    <PromiseDateAndItems
                        shippingMethod={deliveryMethod}
                        isEditView={isEditView}
                        showAutoReplenishItems={true}
                        {...(showSplitEDD && {
                            showSplitEDD,
                            cutOffDescriptionForSplitEdd
                        })}
                    />
                </Box>
            ))}
            {!isEditView && (
                <Link
                    children={deliveryFrequency}
                    color={'blue'}
                    onClick={openAutoReplenishProductsModal}
                    marginTop={4}
                />
            )}
        </>
    );
}

export default wrapFunctionalComponent(AutoReplenishShippingGroups, 'AutoReplenishShippingGroups');
